import React from 'react';
import styles from './EstimatedCost.module.scss';
import { Dollar } from '@zurich-data-dsm-icons/finance.currency.dollar';
import { ICostCard } from './EstimatedCost.interface';
import { Modal } from '@zurich-base-ui/components.modal';
import {
  getIsEstimatedCostModal,
  setIsEstimatedCostModal,
  useAppDispatch,
  useAppSelector
} from 'app/redux';
import { Button } from '@zurich-primitives/button';

export const EstimatedCost: React.FC<ICostCard> = ({
  businessArea,
  service,
  file,
  totalCost,
  currency
}) => {
  const dispatch = useAppDispatch();
  const isCalculatedCostModal: boolean = useAppSelector(
    getIsEstimatedCostModal
  );

  const formatTotalCost = (totalCost: number): string => {
    if (totalCost >= 0.01) {
      return totalCost.toFixed(2);
    } else {
      return '< 0.01';
    }
  };

  return (
    <Modal
      on={isCalculatedCostModal}
      onClose={() => dispatch(setIsEstimatedCostModal(false))}
      variant="slim"
    >
      <div className={styles.modal}>
        <div className={styles.header}>
          <Dollar />
          <p>Cost</p>
        </div>
        <div className={styles.details}>
          <p>Business Area: {businessArea}</p>
          <p>Service Name: {service}</p>
          {file && <p>File: {file?.name}</p>}
        </div>
        {(() => {
          if (totalCost === 0) {
            return (
              <div className={styles['no-cost']}>
                <p>This service does not currently have an associated cost.</p>
              </div>
            );
          }
          return (
            <div className={styles.total}>
              <p>
                Total: {formatTotalCost(totalCost)} {currency}
              </p>
              <span className={styles.disclaimer}>
                The provided cost is an estimation based on input size, token
                count, execution time, and resource usage.
              </span>
            </div>
          );
        })()}

        <Button
          onClick={() => dispatch(setIsEstimatedCostModal(false))}
          className={styles['close-btn']}
        >
          Accept
        </Button>
      </div>
    </Modal>
  );
};
